// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectQuoteMessage } from './DirectQuoteMessage';
import { HistoryType } from '../../Utils/History/HistoryType';
import { Message } from './Message';
export class DirectQuote1Message extends DirectQuoteMessage {
    constructor() {
        super(Message.CODE_QUOTE);
        this.volumeTotal = null;
        this.Bid = Number.NaN;
        this.BidSize = Number.NaN;
        this.Ask = Number.NaN;
        this.AskSize = Number.NaN;
        this.LastPice = null;
        this.LastSize = null;
        this.Open = null;
        this.High = null;
        this.Low = null;
        this.PrevClose = null;
        this.AskOpen = null;
        this.AskHigh = null;
        this.AskLow = null;
        this.AskPrevClose = null;
        this.BidMainClose = null;
        this.AskMainClose = null;
        this.BidVenue = null;
        this.AskVenue = null;
        this.Ticks = null;
        this.TicksPreMarket = null;
        this.TicksPostMarket = null;
        this.VolumePreMarket = null;
        this.VolumePostMarket = null;
        this.OpenInterest = null;
        this.PrevSettlementPrice = null;
        this.TotalVolume = null;
        // Фикс для DirectFX CGQ. Для форексных инструментов история приходит уже сагрегированная, необходимо агрегировать риал тайм данные по тому же алгоритму.
        // Если пришел Ask обновляем бар ask ценой, если bid то bid ценой
        // http://tp.pfsoft.net/entity/63639
        this.updateByBid = null;
        this.Type = HistoryType.QUOTE_LEVEL1;
    }
    // #region TODO. Overloading. SpreadItem.
    BidSpread_SP_Ins(SpreadPlan, ins, round = true) {
        if (SpreadPlan && ins && SpreadPlan.IsNotEmptyPlan(ins)) {
            return SpreadPlan.CalcBid(this.Bid, this.Ask, ins, round);
        }
        else {
            return this.Bid;
        }
    }
    // TODO. Overloading. SpreadItem.
    BidSpread(spreadItem, instrument) {
        return spreadItem ? spreadItem.CalcBid(this.Bid, this.Ask, instrument) : this.Bid;
    }
    // #region TODO. Overloading. SpreadItem.
    AskSpread_SP_Ins(SpreadPlan, ins, round = true) {
        if (SpreadPlan && ins && SpreadPlan.IsNotEmptyPlan(ins)) {
            return SpreadPlan.CalcAsk(this.Bid, this.Ask, ins, round);
        }
        else {
            return this.Ask;
        }
    }
    // TODO. Overloading. SpreadItem.
    AskSpread(spreadItem, instrument) {
        return spreadItem ? spreadItem.CalcAsk(this.Bid, this.Ask, instrument) : this.Ask;
    }
    LastSpread(SpreadPlan, ins) {
        if (SpreadPlan && ins && SpreadPlan.IsNotEmptyPlan(ins)) {
            if (ins.HistoryType === HistoryType.QUOTE_LEVEL1) {
                return SpreadPlan.CalcBid(this.Bid, this.Ask, ins);
            }
            else if (ins.HistoryType === HistoryType.QUOTE_ASK) {
                return SpreadPlan.CalcAsk(this.Bid, this.Ask, ins);
            }
            else if (this.LastPice !== null) {
                return this.LastPice;
            }
            else {
                return ins.Level1.GetLastPrice();
            }
        }
        else {
            if (ins.HistoryType === HistoryType.QUOTE_LEVEL1) {
                return this.Bid;
            }
            else if (ins.HistoryType === HistoryType.QUOTE_ASK) {
                return this.Ask;
            }
            else if (this.LastPice !== null) {
                return this.LastPice;
            }
            else {
                return ins ? ins.Level1.GetLastPrice() : Number.NaN;
            }
        }
    }
    get IsValid() {
        return !isNaN(this.Bid) && !isNaN(this.Ask);
    }
    // TODO.
    GetQuote3Message(previousPrice) {
        return null;
        /*
      var q3m = new Quote3Message();
      q3m.Symbol = Symbol;
      q3m.Route = Route;
      q3m.cTime = cTime;
      q3m.Price = Bid;
      q3m.Size = 1;

      Quote3Message.AgressorFlagType agressor = Quote3Message.AgressorFlagType.None;
      if (!isNaN(previousPrice))
      {
          if (q3m.Price > previousPrice)
              agressor = Quote3Message.AgressorFlagType.Ask;
          else if (q3m.Price < previousPrice)
              agressor = Quote3Message.AgressorFlagType.Bid;
      }
      q3m.LType = agressor;

      return q3m;
    */
    }
}
